import initialQuery from './sources/queries/initialQuery.graphql';
import chartQuery from './sources/queries/chartQuery.graphql';
import structureQuery from './sources/queries/structureQuery.graphql';
import filterStructureQuery from './sources/queries/filterStructureQuery.graphql';
import loginMutation from './sources/mutations/loginMutation.graphql';
import refreshTokenMutation from './sources/mutations/refreshTokenMutation.graphql';
import logoutMutation from './sources/mutations/logoutMutation.graphql';
import actualYearQuery from './sources/queries/actualYear.graphql';
import reportsQuery from './sources/queries/reportsQuery.graphql';
import objectReportsQuery from './sources/queries/objectReportsQuery.graphql';
import {fetch} from './abortPolyfill';

function fetchGraphQL({
  query,
  operationName,
  variables,
  controller
}) {
  const token = localStorage.getItem('token');

  const body = {
    operationName,
    variables,
    query: query.loc.source.body
  };

  return fetch('/graphql', {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    },
    signal: controller ? controller.signal : null,
    body: JSON.stringify(body),
    method: 'POST',
  }).then(response => response.json());
}

export function queryInitial() {
  return fetchGraphQL({
    query: initialQuery,
    operationName: 'initialQuery'
  });
}

export function queryStructure(params = {}) {
  return fetchGraphQL({
    query: structureQuery,
    operationName: 'structureQuery',
    variables: params
  });
}


export function queryStructureFilter(params = {}) {
  return fetchGraphQL({
    query: filterStructureQuery,
    operationName: 'filterStructureQuery',
    variables: params
  });
}

export function queryChart(params = {}, controller) {
  if (!(params.id instanceof Array)) {
    params = {
      ...params,
      id: [ params.id ]
    };
  }
  return fetchGraphQL({
    query: chartQuery,
    operationName: 'chartQuery',
    variables: params,
    controller
  });
}

export function queryReports(params = {}, controller) {
  return fetchGraphQL({
    query: reportsQuery,
    operationName: 'reportsQuery',
    variables: params,
    controller
  });
}

export function queryObjectReports(params = {}, controller) {
  return fetchGraphQL({
    query: objectReportsQuery,
    operationName: 'objectReportsQuery',
    variables: params,
    controller
  });
}

export function mutationLogin(params = {}) {
  return fetchGraphQL({
    query: loginMutation,
    operationName: 'loginMutation',
    variables: params
  });
}

export function mutationRefreshToken(params = {}) {
  return fetchGraphQL({
    query: refreshTokenMutation,
    operationName: 'refreshTokenMutation',
    variables: params
  });
}

export function mutationLogout(params = {}) {
  return fetchGraphQL({
    query: logoutMutation,
    operationName: 'logoutMutation',
    variables: params
  });
}

export function queryActualYear() {
  return fetchGraphQL({
    query: actualYearQuery,
    operationName: 'actualYearQuery'
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/graphql/queries.js